import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { MyValidators } from 'src/app/libs/my-validators';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Cars } from 'src/app/modules/entry-control/interfaces/cars';
import { Drivers } from 'src/app/modules/entry-control/interfaces/drivers';


@Component({
  selector: 'app-list-drivers',
  templateUrl: './list-drivers.component.html',
  styleUrl: './list-drivers.component.css'
})
export class ListDriversComponent implements OnInit, OnChanges {

  error: any;
  constructor(
    private api: ApiEntryControlService,
    private modal: NgbModal,
    private toast: ToastrService,
    private helps:Helps
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['storesId']?.currentValue!=this.storesId){
      this.get();
    }
  }
  view: number = 1;
  status: any;
  selected?: Drivers;
  ngModelDriver:any;
  level:number;
  ngOnInit(): void {
    this.level=this.helps.getToken()?.level;
    this.get();

      this.api.getAllDriverAvailablesStore(this.storesId).subscribe(
        (response) => {
          this.driversAvailables = response.data as Drivers[];
        },
        (error) => {
         this.driversAvailables=[];
        }
      );

  }
  @Input()
  storesId: number;
  @Input()
  car: Cars;
  @Input()
  hiddeAdd:boolean=false;
  @Input()
  cancelActionAdd:boolean=false;
  @Output()
  onClickAdd=new EventEmitter<boolean>();

  items: Drivers[];
  driversAvailables:Drivers[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  brands: any;
  secondForm = new UntypedFormGroup({
    id: new UntypedFormControl(),
  });

  form1=new UntypedFormGroup({
    rut: new UntypedFormControl('',MyValidators.rut),
  });
  formSelected=new UntypedFormGroup({
    drivers_id: new UntypedFormControl(0),
  });

  delete() {
    this.secondForm.get('id')?.setValue(this.selected?.id);
    this.api.deleteDrivers(this.secondForm).subscribe(
      (res) => {
        this.toast.success('Usuario eliminado correctamente', 'CONDUCTORES');
        this.get();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.msg,{enableHtml:true,closeButton:true});
      }
    );
  }
  get() {
    this.api.paginateDrivers(this.page,this.storesId).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as Drivers[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;

        this.totalPage = data.total;
      },
      (error) => {
        this.items = null;
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
        this.toast;
      }
    );
  }
  openModal(md:any, size: string = 'md') {
    this.onClickAdd.emit(true);
    if(!this.cancelActionAdd){
      this.modal.open(md, {
        size: size,
      });  
    }
  }
  openDelete(item: any, md: any,size='md') {
    this.selected = item;
    this.modal.open(md, {
      size: size,
    });
  }
  openEdit(item: any, md: any) {
    this.selected = item;
    this.modal.open(md, {
      size: 'md',
    });
  }
  openSelected(md: any,size='md') {
    var driverId=this.formSelected.get('drivers_id')?.value;
    console.log("selected:",driverId);
    this.selected = this.driversAvailables.find(driver => driver.id === driverId);
    console.log("es:",this.selected);
    this.modal.open(md, {
      size: size,
    });
  }
  search() {
    this.get();
  }
  clean() {}
}

